<template>
  <div>
    <a-form-model
      labelAlign="left"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      ref="ruleForm"
      :rules="rules"
    >
      <a-form-model-item label="Name / Tên ứng dụng" prop="name">
        <a-input v-model="form.name" placeholder="Enter name" />
      </a-form-model-item>
      <a-form-model-item label="URL / Đường dẫn truy cập" prop="url">
        <a-input v-model="form.url" placeholder="Enter URL" />
      </a-form-model-item>
      <a-form-model-item label="Icon" prop="iconUrl">
        <a-input
          v-model="form.iconUrl"
          placeholder="Enter address url of icon"
        />
        <br />
        <div style="max-width: 64px; margin-top: 20px;" v-if="form.iconUrl">
          <img alt="previewIcon" style="width: 100%;" :src="form.iconUrl" />
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <a-checkbox v-model="form.openNewTab">
          Open new tab
        </a-checkbox>
      </a-form-model-item>
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item>
            <a-checkbox v-model="form.isV1">V1</a-checkbox>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item>
            <a-checkbox v-model="form.isV2">V2</a-checkbox>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item label="Number Order">
        <a-input-number
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          :min="0"
          v-model="form.numberOrder"
          placeholder="Enter number..."
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item label="Description / Mô tả">
        <a-textarea
          v-model="form.description"
          placeholder="Enter description"
          :auto-size="{ minRows: 5 }"
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
      style="text-align: right;"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../../constants/query";
const rules = {
  name: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
  url: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
  iconUrl: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
};
const defaultForm = { openNewTab: true, isV1: true, isV2: true };
export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    refreshAfterCreated: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      form: { ...defaultForm },
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      loadingBtn: false,
      rules,
    };
  },
  methods: {
    onAddAppInPlatform() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.createAppInPlatform,
          variables: {
            url: this.form.url,
            iconUrl: this.form.iconUrl,
            name: this.form.name,
            description: this.form.description,
            openNewTab: this.form.openNewTab,
            userCanAccessIds: this.form.userCanAccessIds,
            isV1: this.form.isV1,
            isV2: this.form.isV2,
            numberOrder: this.form.numberOrder,
          },
        })
        .then(({ data }) => {
          if (data?.createAppInPlatform) {
            this.refreshAfterCreated(data.createAppInPlatform);
            this.form = { ...defaultForm };
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Không tạo được thông tin!", error);
        });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onAddAppInPlatform();
        } else {
          console.log("error submit!!");
        }
      });
    },
  },
};
</script>
<style lang="css" scoped></style>
